
import titleImg from './images/title.png';
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Countup from 'vux/src/components/countup/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {promptMessage,fetch} from '@/api/dataHandling';
import {getken} from '@/api/getToken';
import dateFormat from 'vux/src/tools/date/format.js'

import {urlConfig} from '@/api/urlConfig';
export default {

data(){
return {
list: [],
videoList:[],
contact:[],
videoshow:false,
videosrc:'',
titleImg,
toastTxt:'',
videoSrc:'',
passedNum:0,
acceptNum:0,
implmentNum:0,
solveNum:0,
agreeItem:true,
toastShow:false,
options: {
getThumbBoundsFn (index) {
let thumbnail = document.querySelectorAll('.previewer-demo-img')[index]
let pageYScroll = window.pageYOffset || document.documentElement.scrollTop
let rect = thumbnail.getBoundingClientRect()
return {x: rect.left, y: rect.top + pageYScroll, w: rect.width}
}
},
typeZDY:function(value){
return{
valid: value.length == 11,
msg: '手机号码格式不正确！'
}

},
imgData:[],
staffShow:false,
hospitalvalue:'',
nullshow:false,
nullplaceholder:'请选择',
msgSubmitdisabled:false,
officesValue:'',
sayTitle:'',
hospitallist:[
],
sayvalue:'',
saylist:[
],
nullvalue:'',
nulllist:[
],
textareaValue:'',
replyvalue:'',
replylist:[
{key:'1',value:'是'},
{key:'2',value:'否'},
],
nameValue:'',
telValue:'',
needtelValue:'',
needshow:false,
hospitalshow:false,
needTellshow:false,
}

},
components: {
XDialog, Toast, Card,Countup, Grid, GridItem,CheckIcon,Alert,Confirm,XInput,Radio, Group, Cell, XTextarea, XButton, PopupRadio,Previewer, Flexbox, FlexboxItem, Divider
},
directives: {
TransferDom
},
methods:{
videoDialog(src){
this.videosrc = src;
this.videoshow = true;

},
deleImgClick(index,list){

for(let t = 0;t<this.contact.length;t++){
if(this.contact[t].src == list[index].src){
list.splice(index,1)
this.contact.splice(t,1)
fetch('post',urlConfig.imgDelete +'?delFile=' + this.imgData.splice(t,1).toString()).then(response =>{
this.toastTxt = '图片已删除';
this.toastShow = true;
}).catch(error =>{
});
}
}
},
show (index) {
this.$refs.previewer.show(index)
},
postData(){
this.paramsData = {};
this.paramsData.roast_type = this.personname;
this.paramsData.roast_date = dateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss');
this.paramsData.tel = this.needtelValue;
this.paramsData.reply = this.replyvalue;
this.paramsData.roast_content = this.textareaValue;
this.paramsData.roastTypeId = this.sayvalue;
this.paramsData.roastUserName = this.nameValue;
this.paramsData.status = '';
this.paramsData.uuid = '';
this.paramsData.hospitalId = this.hospitalvalue;
this.paramsData.roast_img = this.imgData.toString();

fetch('post',urlConfig.saveSurveyurl,this.paramsData).then(response => {
this.$store.commit('updateLoadingStatus',{isLoading:false});
if(this.needTellshow || this.hospitalshow){
this.msgSubmitdisabled = true;
promptMessage('提示','非常感谢您的反馈，我们将于1-2个工作日回复您！',this.alertHide());
}else {
promptMessage('提示','感谢您的信息提交！您提出的每一项内容，我们都将用心倾听。',this.alertHide());
}

}).catch(error => {
promptMessage('提示','提交失败，请重新提交');
this.$store.commit('updateLoadingStatus',{isLoading:false});
})

}, //需要提交的数据
confirmdialog(){
this.$vux.confirm.show({
title: '提示',
content: '是否继续吐槽？',
confirmText:'继续吐槽',
cancelText:'不吐槽',
onCancel () {

var ua = navigator.userAgent.toLowerCase();
var isWeixin = ua.indexOf('micromessenger') != -1;
if (isWeixin) {
WeixinJSBridge.call('closeWindow');
}else{
window.location.href="about:blank";
window.opener = null;
window.open("", "_self");
window.close();


}
},
onConfirm () {
window.location.reload();
}
})
},
msgSubmit(){
if(this.agreeItem){
if(this.hospitalvalue != '' && this.sayvalue != '' && this.textareaValue != ''){
if(this.needshow){  //是否需要回复
if(this.needTellshow){  //已选择需要回复
if(this.nullshow){
if(this.personname == 200){
if(this.nameValue != '' && this.needtelValue != ''&& this.nullvalue != '' && this.officesValue != '' && this.typeZDY(this.needtelValue).valid){  //可以提交
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.postData();

}else{
promptMessage('提示','还有选项未填写！')
}
}else if(this.personname == 300){
if(this.nameValue != '' && this.needtelValue != ''&& this.nullvalue != '' && this.typeZDY(this.needtelValue).valid){  //可以提交
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.postData();

}else{
promptMessage('提示','还有选项未填写！')

}
}

}else {   //如果第三步不存在
if(this.personname == 200){
if(this.nameValue != '' && this.needtelValue != '' && this.officesValue != '' && this.typeZDY(this.needtelValue).valid){  //可以提交
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.postData();

}else{
promptMessage('提示','还有选项未填写！')
}
}else if(this.personname == 300){
if(this.nameValue != '' && this.needtelValue != '' && this.typeZDY(this.needtelValue).valid){  //可以提交
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.postData();

}else{
promptMessage('提示','请输入姓名和联系电话！')
}
}

}

}else {  //未选择需要回复
if(this.nullshow){
if(this.replyvalue == '2' && this.nullvalue != ''){  //否  //可以提交
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.postData();

}else{  //是
if(this.nullvalue == ''){
promptMessage('提示','还有选项未选择！')
}else {
promptMessage('提示','请选择是否需要回复！')
}

}
}else {
if(this.replyvalue == '2'){  //否  //可以提交
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.postData();

}else{  //是
promptMessage('提示','请选择是否需要回复！')
}
}

}

}else {
if(this.nullshow){
if(this.telValue != '' && this.nullvalue != '' && this.nameValue != '' && this.typeZDY(this.telValue).valid){  //可以提交
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.postData();
}else {
promptMessage('提示','还有选项未填写！')
}
}else {
if(this.telValue != '' && this.nameValue != '' && this.typeZDY(this.telValue).valid){  //可以提交
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.postData();
}else {
if(this.sayvalue == '205' || this.sayvalue == '305'){
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.postData();
}else {
promptMessage('提示','还有选项未填写！');
}

}
}

}

}else {
promptMessage('提示','还有选项未选择！')
}

}else {
promptMessage('提示','请勾选我已知晓！')
}

},   //提交
sayclick(){

this.nulllist = [];
this.nullvalue = '';
this.replyvalue = '';
if(this.sayvalue !=''){
if(this.personname ==200){
if(this.sayvalue == '201'){  //如果是参与院区整改
this.needshow = false;
this.hospitalshow = true;
this.needTellshow = false;
this.nullshow = false;
}else{
this.needshow = true;
this.hospitalshow = false;
this.needTellshow = false;
this.nullshow = false;
}

}else if(this.personname ==300){

if(this.sayvalue == '303'){  //如果是参与院区整改
this.needshow = false;
this.hospitalshow = true;
this.needTellshow = false;
this.nullshow = true;
this.nullplaceholder = '请选择';
}else if(this.sayvalue == '305'){
this.nullplaceholder = '请选择';
this.nullshow = false;
this.hospitalshow = false;
this.needTellshow = false;
this.needshow = false;
}else{
this.needshow = true;
this.hospitalshow = false;
this.needTellshow = false;
this.nullshow = true;
if(this.sayvalue == '306'){
this.nullplaceholder = '请选择您将点赞表扬的工作人员';
}else {
this.nullplaceholder = '请选择';
}
}
}

if(this.nullshow){
fetch('post',urlConfig.getsayurl+'?parentNo='+this.sayvalue).then(response => {
let data = response
for(let i = 0; i<data.length;i++){
this.nulllist.push({});
this.nulllist[i].key = data[i].no;
this.nulllist[i].value = data[i].name;

}
this.nullshow = true;

}).catch(error => {
})
}
}

},  //我想对你说
needclick(){
if(this.replyvalue == '1'){  //是
this.needTellshow = true;

}else{  //否
this.needTellshow = false;
}
},  //是否需要回复
gethospitalData(){
this.$store.commit('updateLoadingStatus',{isLoading:true});
fetch('post',urlConfig.gethospitalurl).then(response => {
this.data = response
for(let item in this.data){
if(this.data[item].id == '66' || this.data[item].id == '56'){

}else {
this.hospitallist.push({key:this.data[item].id,value:this.data[item].name});
}
}

}).catch(error => {

})
},
getsayData(){
this.personname = this.$route.query.personname;
if(this.personname == 200){   //员工
this.staffShow = true;
this.sayTitle = '锦欣生殖,有些心里话我想对你说'

}else if(this.personname == 300){  //患者
this.staffShow = false;
this.sayTitle = '我想对你说';
}

this.roastData = new URLSearchParams();
this.roastData.append('roastType',this.personname);
fetch('post',urlConfig.getShowData + '?roastType=' + this.personname).then(response => {
console.log(response,56)
this.passedNum = response.passedNum;
this.acceptNum = response.acceptNum;
this.implmentNum = response.implmentNum;
this.solveNum  = response.solveNum;
}).catch(error => {

});
fetch('post',urlConfig.getsayurl + '?parentNo=' + this.personname).then(response => {

this.$store.commit('updateLoadingStatus',{isLoading:false});
let data = response
for(let i = 0; i<data.length;i++){
this.saylist.push({});
this.saylist[i].key = data[i].no;
this.saylist[i].value = data[i].name;

}

}).catch(error => {

})
},
alertHide(txt){
var _this = this;
return function(){
_this.confirmdialog();
}
},
getUrlParam (name) {
var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
let url = location.href;
let search = url.split('?')[1]
if (search) {
var r = search.substr(0).match(reg)
if (r !== null) return decodeURI(r[2])
return null
} else {
return null
}
}
},

mounted(){
console.log(location.href)
this.hospitalvalue="54";
if(this.$route.query.hosCode=='510100000008'){
this.hospitalvalue="53";
}
console.log("this.hospitalvalue="+this.hospitalvalue);
getken(this.getsayData); 

var _this = this;
let inputref = _this.$refs.uploadref;
var uploadBtn = document.querySelector('#upload');
uploadBtn.addEventListener('change',function(){
_this.$store.commit('updateLoadingStatus',{isLoading:true});
var imgLen = this.files.length;
var ImgLen = imgLen + _this.list.length ;
for(var i = 0; i < imgLen;i++){
var file = this.files[i];
if((file.size/1024)/1024 > 10){ // 如果大于10M
promptMessage('提示','上传图片过大，无法上传！');
return false;
}
var img = document.createElement("img");
var reader = new FileReader();
reader.onload = (function(aImg) { return function(e) {
aImg.src = e.target.result;
if(file.type.indexOf("video") != -1){
_this.videoList.push(
{
src: e.target.result,
})
_this.contact.push({
src: e.target.result,
})
}else if(file.type.indexOf("image") != -1){
_this.list.push(
{
msrc: e.target.result,
src: e.target.result,
})
_this.contact.push({
msrc: e.target.result,
src: e.target.result,
})

}

};

})(img);
reader.readAsDataURL(file);
}
var fromUpdate = new FormData();
let filesLength  = inputref.files.length;
fromUpdate.append('filepath','tucao/' + dateFormat(new Date(), 'YYYY-MM-DD'));
fromUpdate.append('rename','true');

if(filesLength <= 1){  //单图上传
fromUpdate.append('uploadfile',inputref.files[0]);
fetch('post',urlConfig.imgUpdate,fromUpdate).then(response => {
_this.imgData.push(response.filename);
_this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

if(file.type.indexOf("video") != -1){
_this.videoList.splice(_this.videoList.length-1,1);
_this.contact.splice(_this.contact.length-1,1);
}else if(file.type.indexOf("image") != -1){
_this.list.splice(_this.list.length-1,1);
_this.contact.splice(_this.contact.length-1,1);
}
promptMessage('提示','图片上传失败，请重新上传！')
});
}
_this.$refs.uploadref.value = null;

},false);


}
}



// WEBPACK FOOTER //
// ./src/project/ValuationProject/SystemSurvey.vue